import { graphql } from 'react-relay';
export const LabelsCountQuery = graphql`
	query LabelCountQuery($contentId: ID!, $status: [String]) {
		singleContent(id: $contentId, status: $status) {
			id
			labels(orderBy: { sortField: LABELLING_CREATIONDATE, direction: ASCENDING }) {
				count
			}
		}
	}
`;
